module.exports = __webpack_public_path__ + "static/img/caseDetails_BYD_01_zh.d860aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseDetails_BYD_01_zh.png
// module id = PIR4
// module chunks = 34